const state = {
  pageConfig: null,
  curCounty: null
}

const mutations = {
  SET_PAGECONFIG: (state, config) => {
    state.pageConfig = config
  },
  SET_CURCOUNTY: (state, config) => {
    state.curCounty = config
  },
  DELETE_CURCOUNTY: (state) => {
    state.curCounty = null
  }
}

const actions = {
  setConfig ({ commit }, config) {
    commit('SET_PAGECONFIG', config)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
